import { render, staticRenderFns } from "./ComplaintsReport.vue?vue&type=template&id=6c3cdf3e&"
import script from "./ComplaintsReport.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports